import React from 'react';
import { Form, Input, AutoComplete } from 'antd';
import { useFetchBankOptions } from '../hooks/useFetch';

function FormUserBank({ formRef, onFinish, initialValues = {} }) {
  const { data: bankOptions = [], isLoading } = useFetchBankOptions();

  return (
    <Form
      name="FormUserBank"
      ref={formRef}
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
    >
      <div className="mt-5 grid lg:gap-x-5 lg:grid-cols-2">
        <Form.Item
          className="block mb-2 text-sm font-medium text-gray-700"
          name="phone"
          label="เบอร์โทร"
          rules={[
            { required: true, message: 'กรุณาระบุเบอร์โทร' },
            { pattern: /^\d{9,10}$/, message: 'เบอร์โทรต้องเป็นตัวเลข 9-10 หลัก' },
          ]}
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="เช่น 0953988788"
            maxLength={10}
          />
        </Form.Item>

        <Form.Item
          className="block mb-2 text-sm font-medium text-gray-700"
          name="name"
          label="ชื่อ-นามสกุล"
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="ชื่อเจ้าของบัญชี"
          />
        </Form.Item>

        <Form.Item
          className="block mb-2 text-sm font-medium text-gray-700"
          name="bank"
          label="ธนาคาร"
        >
          <AutoComplete
            options={bankOptions.map((bank) => ({ value: bank }))}
            placeholder="เช่น กสิกรไทย"
            filterOption={(input, option) =>
              String(option?.value || '').toLowerCase().includes(String(input).toLowerCase())
            }
            allowClear
            disabled={isLoading}
          />
        </Form.Item>

        <Form.Item
          className="block mb-2 text-sm font-medium text-gray-700"
          name="bankId"
          label="เลขที่บัญชี"
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="เลขที่บัญชีธนาคาร"
            maxLength={50}
          />
        </Form.Item>

        {/* 4 ช่องนี้ปกติได้มาจากการ sync แต่คนที่สมัครก่อนเว็บเพิ่มคอลัมน์จะไม่มีค่า จึงต้องแก้มือได้ */}
        <Form.Item
          className="block mb-2 text-sm font-medium text-gray-700"
          name="betflix"
          label="BETFLIX"
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="ยูสเซอร์ฝั่ง BETFLIX"
            maxLength={100}
          />
        </Form.Item>

        <Form.Item
          className="block mb-2 text-sm font-medium text-gray-700"
          name="sportbook"
          label="SPORTBOOK"
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="ยูสเซอร์ฝั่ง SPORTBOOK"
            maxLength={100}
          />
        </Form.Item>

        <Form.Item
          className="block mb-2 text-sm font-medium text-gray-700"
          name="memberId"
          label="รหัสสมาชิก"
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="เช่น USA9w8xGl"
            maxLength={50}
          />
        </Form.Item>

        <Form.Item
          className="block mb-2 text-sm font-medium text-gray-700"
          name="username"
          label="ยูสเซอร์"
        >
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="ยูสเซอร์ที่ลูกค้าตั้งเอง"
            maxLength={100}
          />
        </Form.Item>
      </div>
    </Form>
  );
}

export default FormUserBank;
